import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "backgroundImage", "color", "divider", "gradientAngle", "sticky"];
// @ts-expect-error svgs are untyped modules
import blobsImageUrl from 'bender-url!marketplace-ui-common/img/storefront-header-blobs.svg';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import { GLOBAL_NAVIGATION_TOOLBAR_HEIGHT } from 'nav-meta/constants';
import { forwardRef } from 'react';
import styled, { useTheme } from 'styled-components';
import { GRID_BREAKPOINT_SMALL } from '../../layout/constants';
import { useStorefrontHeaderBackgroundStyles } from './StorefrontHeader.utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledStorefrontHeaderView = styled.div.withConfig({
  displayName: "StorefrontHeaderView__StyledStorefrontHeaderView",
  componentId: "sc-7pon59-0"
})(({
  $backgroundImage,
  $color,
  $cssStyles,
  $divider,
  $gradientAngle,
  $sticky
}) => {
  const theme = useTheme();
  const backgroundStyles = useStorefrontHeaderBackgroundStyles({
    backgroundImage: $backgroundImage || `url(${blobsImageUrl})`,
    color: $color,
    gradientAngle: $gradientAngle
  });
  const mobileBackgroundStyles = useStorefrontHeaderBackgroundStyles({
    color: $color,
    gradientAngle: $gradientAngle
  });
  return Object.assign({}, $cssStyles, backgroundStyles, {
    padding: $sticky ? `0 0 ${GLOBAL_NAVIGATION_TOOLBAR_HEIGHT}` : `0 ${theme.space['400']}`,
    width: '100%',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    borderTop: $divider ? `1px solid ${theme.color['border-primary-subtle']}` : 'none',
    [`@media screen and (max-width: ${GRID_BREAKPOINT_SMALL})`]: mobileBackgroundStyles
  });
});
export const StorefrontHeaderView = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as = 'div',
      children,
      backgroundImage,
      color = 'blue',
      divider,
      gradientAngle,
      sticky
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledStorefrontHeaderView, Object.assign({}, domProps, {
    $backgroundImage: backgroundImage,
    $color: color,
    $cssStyles: cssStyles,
    $divider: divider,
    $gradientAngle: gradientAngle,
    $sticky: sticky,
    as: as,
    ref: ref,
    children: children
  }));
});